
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"56","height":"58"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D6D8DA","fill-rule":"evenodd","d":"M37.333 26.407c3.874 0 6.977-3.154 6.977-7.062 0-3.907-3.103-7.062-6.977-7.062-3.873 0-7 3.155-7 7.062 0 3.908 3.127 7.062 7 7.062zm-18.666 0c3.873 0 6.976-3.154 6.976-7.062 0-3.907-3.103-7.062-6.976-7.062-3.874 0-7 3.155-7 7.062 0 3.908 3.126 7.062 7 7.062zm0 4.708c-5.437 0-16.334 2.754-16.334 8.239v3.531c0 1.295 1.05 2.354 2.334 2.354h28c1.283 0 2.333-1.06 2.333-2.354v-3.531c0-5.485-10.897-8.239-16.333-8.239zm18.666 0c-.676 0-1.446.047-2.263.118.047.023.07.07.093.094 2.66 1.954 4.504 4.567 4.504 8.027v3.531c0 .824-.164 1.624-.42 2.354h12.086c1.284 0 2.334-1.06 2.334-2.354v-3.531c0-5.485-10.897-8.239-16.334-8.239z"}})])
          )
        }
      }
    